import { IGroupAlertBehavior } from "./IGroupAlertBehavior";

export interface IGroupAlertBehaviorSpecifiable {
  groupAlertBehavior: IGroupAlertBehavior;
}

export function instanceOfIGroupAlertBehaviorSpecifiable(instance: any): instance is IGroupAlertBehaviorSpecifiable {
  return instance
    && (instance.groupAlertBehavior !== undefined);
}
